import { createContext, useContext, useEffect, useState, useLocation } from "react";
import gameConfig from '../gameConfig'
import useWebSocket from 'react-use-websocket';

const GameStateContext = createContext({});

export const GameStateContextProvider = ({ win, children, onJackpotChanged }) => {
    const [state, setState] = useState('Idle');
    const [jackpots, setJackpots] = useState([]);
    const [activeLines, setActiveLines] = useState(['main']);
    const [costs, setCosts] = useState([]);
    const [activeLocks, setActiveLocks] = useState([]);
    const [credit, setCredit] = useState(1000);
    const [freeGames, setFreeGames] = useState(0);
    const [symbols, setSymbols] = useState([[1, 2, 3, 10, 11, 12], [4, 5, 6, 13, 14, 15], [7, 8, 9, 0, 1, 2]]);
    const [response, setResponse] = useState({});
    

    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    console.log("WebSocket Protocol: ",  window.location.protocol);
    const url = protocol + window.location.host;
    //const url = 'ws://localhost:8080';
    //const url = 'ws://192.168.178.81:8080';
    console.log("New Connecting Websocket to ", url);
    const ws = useWebSocket(url, {
        shouldReconnect: (closeEvent) => true,
        onOpen: () => {
            console.log("ws connected");
        },
        onMessage: (res) => {
            var msg = JSON.parse(res.data);
            console.log("ws onMessage", msg);
            
            if (msg.type === 'jackpotInit'){
                setJackpots(msg.jackpots);
                console.log("Jackpot Init Received", msg.jackpots);
            }
            else if (msg.type === 'jackpotUpdate'){
                setJackpots(msg.jackpots);
                console.log("Jackpot Update Received", msg.jackpots);
            }
            else if (msg.type === 'jackpotChanged'){
                msg.jackpots[msg.name]['changed'] = true;
                setJackpots(msg.jackpots);                
                console.log("Jackpot Changed Received", msg.jackpots);
            }
        }
    })

    useEffect(() => {
        //if (state === 'Idle' || state === 'winAnimation1' || state === 'winAnimation2')
        //   setActiveLocks([]);

        if (state === 'spin1' || state === 'spin2') {
            fetch('/api/run', {
                method: 'POST',
                headers: {
                    accept: 'application.json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(providerValue),
                cache: 'default'
            })
                .then(function (response) {
                    return response.ok
                        ? Promise.resolve(response)
                        : Promise.rejects(response.statusText);
                })
                .then((res) => res.json())
                .then((data) => {
                    setResponse(data);
                    setSymbols(data.symbols);
                    if (data.win && Object.keys(data.win).length > 0) {
                        if (data.win.money)
                            incCredit(data.win.money);
                        if (data.win.freeGames)
                            incFreeGames(data.win.freeGames)
                    }
                    setState((state === 'spin1') ? 'winAnimation1' : 'winAnimation2');
                    resetLocks();

                    console.log(data);
                })
                .catch(() => {
                    console.log("error fetching api");
                    setState({ status: -1 });
                });
        }
        
        if (state === 'freeGameWait')
            setInterval(()=>setState('spin2'), 2000);
    }, [state])

    useEffect(() => {
        setCosts(activeLines.map((l) => gameConfig.lines[l].costs).reduce((sum, cost) => sum + cost, 0.0));
    }, [activeLines])

    const onSetActiveLine = (line, checked) => {
        if (checked && !activeLines.includes(line))
            setActiveLines([...activeLines, line])
        if (!checked && activeLines.includes(line))
            setActiveLines(activeLines.filter((lineName) => lineName !== line));
    }

    const spin = () => {
        if (state === 'Idle') {
            setCredit(credit - costs);
            setState('spin1');
        } else if (state === 'Second') {
            setCredit(credit - costs);
            setState('spin2');
        }
    }

    const incCredit = (amount) => setCredit(credit + amount);
    const incFreeGames = (amount) => setFreeGames(freeGames + amount);

    const setLock = (reel, state) => {
        if (state && !activeLocks.includes(reel))
            setActiveLocks([...activeLocks, reel])
        if (!state && activeLocks.includes(reel))
            setActiveLocks(activeLocks.filter((r) => r !== reel));
    }
    const getLock = (reel) => activeLocks.includes(reel);
    const resetLocks = () => setActiveLocks([]);
    const onSetState = (targetState) => {
        setState(targetState);
    }

    const onAnimationFinished = () => {
        if (state === 'winAnimation1' && response.win) {
            setState('winAnimationDisplay1');
            return;
        }

        if (state === 'winAnimation2' && response.win) {
            setState('winAnimationDisplay2');
            return;
        }

        if (freeGames > 0) {
            setFreeGames(freeGames - 1)
            setState('spin2')
            console.log("Freegame")
        } else {
            if (state === 'winAnimation1')
                setState('Second');
            else if (state === 'winAnimation2' || state ==="winAnimationDisplay1" || state ==="winAnimationDisplay2")
                setState('Idle');
        }
    }
    const providerValue = {
        state: state,
        setState: onSetState,
        data: null,
        activeLines: activeLines,
        setActiveLine: onSetActiveLine,
        turnCosts: costs,
        activeLocks: activeLocks,
        spin: spin,
        credit: credit,
        incCredit: incCredit,
        setLock: setLock,
        getLock: getLock,
        resetLocks: resetLocks,
        incFreeGames: incFreeGames,
        onAnimationFinished: onAnimationFinished,
        freeGames: freeGames,
        response : response,
        symbols : symbols,
        jackpots: jackpots
    }
    return (
        <GameStateContext.Provider value={providerValue}> {children} </GameStateContext.Provider>
    )
}

export const useGameStateContext = () => useContext(GameStateContext)